import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { LevelMoveEligibility } from 'store/level-move/models';
import { CmsLevelMoveEligibility } from 'store/cms/models';
import { StoreAction } from 'store/actions';

@Component({
    selector: 'xm-level-move-eligibility',
    templateUrl: './eligibility.html',
    styleUrls: ['./eligibility.scss'],
    standalone: false
})
export class XmLevelMoveEligibility implements OnInit, OnDestroy {
    public pageData: CmsLevelMoveEligibility;
    public icon: MediaImageOptions;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private state: StateService;

    constructor(state: StateService, xmStore: XmStore) {
        Object.assign(this, { state, xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsLevelMoveEligibility>(CmsLevelMoveEligibility), (result: CmsLevelMoveEligibility) => {
            this.pageData = result;
            this.icon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.icon)
            };

            this.checkEligibility();
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    private checkEligibility(): void {
        this.xmStore.fetchPromise(StoreAction.GET_LEVEL_MOVE_ELIGIBILITY).then((response: LevelMoveEligibility) => {
            if (response.isEligible) {
                this.state.go('account.settings.level-move.start');
            } else {
                this.state.go('account.settings.level-move.ineligible', { errorCode: response.denialReason[0].code });
            }
        }).catch(() => {
            this.state.go('account.settings.level-move.error');
        });
    }

}
